import service from "./service"

const retrieveCandidateResults = async (data) => {
    return service(data)
}

export default retrieveCandidateResults
